import Color from 'color';
import { useMuted } from '../index';

const useIsMutedDark = () => {
  const muted = useMuted();
  return Color(muted).isDark();
};

export default useIsMutedDark;
